import { Plot } from '../../core/plot';
import { Adaptor } from '../../core/adaptor';
import { getTinyData } from '../tiny-line/utils';
import { TinyAreaOptions } from './types';
import { adaptor, meta } from './adaptor';
import { DEFAULT_OPTIONS } from './constants';

export type { TinyAreaOptions };

export class TinyArea extends Plot<TinyAreaOptions> {
  /**
   * è·åé»è®¤éç½®é¡¹
   * ä¾å¤é¨ä½¿ç¨
   */
  static getDefaultOptions(): Partial<TinyAreaOptions> {
    return DEFAULT_OPTIONS;
  }

  /** å¾è¡¨ç±»å */
  public type: string = 'tiny-area';

  /**
   * @override
   * @param data
   */
  public changeData(data: TinyAreaOptions['data']) {
    this.updateOption({ data });
    const { chart, options } = this;
    meta({ chart, options });
    chart.changeData(getTinyData(data));
  }

  protected getDefaultOptions() {
    return TinyArea.getDefaultOptions();
  }

  /**
   * è·å è¿·ä½ é¢ç§¯å¾ çééå¨
   */
  protected getSchemaAdaptor(): Adaptor<TinyAreaOptions> {
    return adaptor;
  }
}
